
import React,{useEffect} from "react";
import {MDBNavbar} from "mdbreact";
import './footer.css'
export default function Header() {
    // useEffect(()=>{

    //     document.getElementById('cookie-consent-banner__cta')

    // },[]);
    function fadeSlow(){
        document.getElementById('cookie-consent-banner').classList.add('fade-out')
        setTimeout(()=>{
            
            document.getElementById('cookie-consent-banner').style ="display:none"
        },1700)
        

    }
    return (
        <>
        <div class="cookie-consent-banner" id="cookie-consent-banner">
            <div class="cookie-consent-banner__inner">
                <div class="cookie-consent-banner__copy">
                {/* <!--<div class="cookie-consent-banner__header">THIS WEBSITE USES COOKIES</div>--> */}
                <div class="cookie-consent-banner__description">We use cookies to ensure you get the best experience on our website.
                    <button class="cookie-consent-banner__cta btn btn-success" id="cookie-consent-banner__cta" onClick={fadeSlow}>Close</button>
                    {/* <!--<button class="cookie-consent-banner__cta cookie-consent-banner__cta--secondary">Decline</button>--> */}
                </div>
                </div>
            </div>
        </div>
        <MDBNavbar
            color="light"
            dark
            expand="md"
            className="site-footer d-flex flex-column align-items-center fixed-bottom"
        >
            Passport Doc Pros is not affiliated with the US Government
        </MDBNavbar>
        </>
       
    );
}